var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 480,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pause") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "g3368"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m458.936768,253.001755l-82.238159,43.34642l-82.238159,43.346527l0.313446,-87.194794l0.316437,-87.194672l81.921875,43.848297l81.924561,43.848221z",
    strokeOpacity: 0.182573,
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    stroke: "#ffffff",
    fillRule: "evenodd",
    fill: "#e6e6e6",
    id: "svg_12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.d4a7aca781c09162bcebfe47a55d849d.svg";
export { ForwardRef as ReactComponent };